import { Spin } from 'antd';

/** 全局统一 loading（getInitialState / 菜单 bootstrap 共用） */
const AppLoading: React.FC = () => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
    }}
  >
    <Spin size="large" />
  </div>
);

export default AppLoading;
